<template>
  <div class="col-md-4" :id="`user_${data.id}`" style="margin: 15px 0px;">
    <div
      class="col-md-12"
      :style="{ backgroundColor: selecionado ? '#d6eaf8' : '#ecf0f1', padding: '15px', cursor: selecionavel ? 'pointer' : 'default', boxShadow: selecionado ? 'inset 0 0 0 2px #3490dc' : 'none', userSelect: selecionavel ? 'none' : 'auto', opacity: inativo ? 0.6 : 1 }"
      @click="alternar"
    >
      <!-- SELEÇÃO PARA ALTERAÇÃO DE FILAS EM LOTE -->
      <div v-if="selecionavel" style="position: absolute; top: 6px; left: 8px; z-index: 1;">
        <input type="checkbox" :checked="selecionado" @click.stop="alternar" style="cursor: pointer; width: 16px; height: 16px;" :aria-label="`Selecionar ${data.name}`" />
      </div>
      <div class="row">
        <div class="col-md-4 d-none d-md-block d-lg-block">
          <img v-if="data.photo != null"
            :src="`/storage/${data.photo}`"
            alt="Imagem de perfil"
            class="rounded-circle"
            style="width: 100%"
          />
           <img v-else
            src="/imgs/default-profile.png"
            alt="Imagem de perfil"
            class="rounded-circle"
            style="width: 100%"
          />
        </div>
        <div class="col-md-8" style="font-size: 12px;">
          <strong>Nome:</strong>
          {{data.name}}
          <br />
          <strong>Ramal:</strong>
          {{data.extension_line}}
          <br />
        <strong>Login:</strong>
          {{data.login}}
          <br />
          <strong>Situação:</strong>
          <span v-if="inativo" class="badge badge-secondary">Inativo</span>
          <span v-else class="badge badge-success">Ativo</span>
          <br />
          <span v-if="logado" class="text-success" :title="logado.pausado ? 'Em pausa' : ''">
            <i class="fas fa-circle" style="font-size: 9px;"></i>
            Logado em {{ logado.fila }}<span v-if="logado.pausado"> (pausa)</span>
          </span>
 

          <div class="row mt-1">
            <div class="col-12">
          <button :id="`editUser_${data.id}`" v-on:click.stop="editUser()" class="btn btn-outline-primary hiddenButton"><i class="fas fa-edit"></i> Editar</button>
          <button :id="`deleteUser_${data.id}`" v-on:click.stop="deleteUser()" class="btn btn-outline-danger hiddenButton"><i class="fas fa-times"></i> Excluir</button>
          </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: {data:{
          type: Object,
          default: () => ({})
        },
        selecionavel: { type: Boolean, default: false },
        selecionado: { type: Boolean, default: false },
        logado: { type: Object, default: null }},
        computed: {
          // at_users.situacao: 1 = ATIVO, 0 = INATIVO (SEM A COLUNA, CONSIDERA ATIVO)
          inativo: function () {
            return this.data.situacao !== undefined && this.data.situacao !== null && Number(this.data.situacao) === 0;
          }
        },
        mounted() {

        },
        methods:
         {
          alternar: function (event) {
            if (!this.selecionavel) return;
            this.$emit('alternar', { id: this.data.id, shift: event.shiftKey });
          },

          editUser: function () {
            $("#password, #confirmPassword").prop("required", false);
            var key = Object.keys;
              var value = Object.values;

      
              for (key in this.data) {
                if (this.data.hasOwnProperty(key)){
                  $('input[name=' + key + ']').val(this.data[key]);
                  $('select[name=' + key + ']').val(this.data[key]);

              if(this.data.queuechat) {
                $("#queuechat_input").val(this.data.queuechat);
              }

              if(this.data.photo == null){
                $('#imagePreview').css('background-image', 'url(/imgs/default-profile.png)');
              } else{
                $('input[name=photo]').val(this.data.photo);
                 $('#imagePreview').css('background-image',`url(/storage/${this.data.photo})`);
              }

                }
              }

              window.dispatchEvent(new CustomEvent('filas-checkbox:definir', { detail: { id: 'queue', valores: this.data.queue || [] } }));

              $(this.data.permission).each(function(index, item){
                 $('input[id=' + item + ']').prop('checked', true);
              })
  

              $("#usersModal").modal("show");
            },

          deleteUser: function(){
            var key = Object.keys;
            $('#deleteUserName').text(`${this.data.name}`);
            $("#deleteUserModal").modal("show");
                for (key in this.data) {
                if (this.data.hasOwnProperty(key)){
                   $('input[name=' + key + ']').val(this.data[key]);
              }
              }
          }
        }
    };
</script>